import { C } from '../../theme.js';
import { Eyebrow, FieldLabel, TextInput } from '../../components/Primitives.jsx';
import { MultiCols } from '../shared/MultiCols.jsx';

// ── Right trim inspector ────────────────────────────────────────────────
export function RightTrimInspector({ step, onChange }) {
  const c = step.config || {};
  const sel = c.columns || [];
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <Eyebrow>Right trim columns</Eyebrow>
      <div style={{ color: C.fg4, fontSize: '.78rem', margin: '4px 0 10px', lineHeight: 1.5 }}>
        Strips trailing characters from the chosen string columns.
        With no columns selected, every string column is right-trimmed.
      </div>
      <MultiCols selected={sel} onChange={(v) => u({ columns: v })} />
      <FieldLabel hint="Blank = all trailing whitespace">Character count</FieldLabel>
      <TextInput mono value={c.count != null ? String(c.count) : ''} onChange={(v) => u({ count: v.trim() === '' ? null : (parseInt(v) || 0) })} placeholder="All whitespace" />
    </div>
  );
}
